module.exports = __webpack_public_path__ + "static/img/guest1.ee68f91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/guest1.jpg
// module id = D2vU
// module chunks = 0